import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useLanguage } from "../../../../../i18n/useLanguage";
import { MandatoryLineItem } from "../../../../../stores/slices/cartSlice";
import { KeyValue } from "../../../../../ui/KeyValue/KeyValue";
import { PriceDisplay } from "../../../../../ui/PriceDisplay/PriceDisplay";

type MandatoryItemProps = {
  item: MandatoryLineItem;
};

export const MandatoryItem: FunctionComponent<MandatoryItemProps> = ({
  item,
}) => {
  const { t } = useTranslation();
  const [language] = useLanguage();
  return (
    <div className="grid grid-cols-4 py-2">
      <strong className="font-medium">
        {item.title[language] || item.title["en"]}
      </strong>
      <KeyValue>
        <>{t("cart.price")}:</>
        <PriceDisplay>{Number(item.price) / Number(item.qty)}</PriceDisplay>
      </KeyValue>
      <KeyValue>
        <>{t("cart.quantity")}:</>
        <>{item.qty}</>
      </KeyValue>
      <KeyValue>
        <>{t("cart.totalPrice")}:</>
        <PriceDisplay>{item.price}</PriceDisplay>
      </KeyValue>
    </div>
  );
};
